import React from "react";

import './footer.css'

import data from '../../data/data-layouts/data-Footer.json'


function Footer(){

  return(
    <footer id="contactInfo" className="main-footer text-center">
		<div className="widgets-section padding-top-small padding-bottom-small">
		 <div className="container">

		    <div className="row clearfix">

		       <div className="footer-column col-md-6 col-sm-6 col-xs-12">
		          <div className="footer-widget about-widget">
		             <h3 className="has-line-center">About Us</h3>
		             <div className="widget-content">
		                <div className="text">ATTACK WAGON GAMES IS A BLOCKCHAIN VIDEO GAME STUDIO BRINGING YOU FREE-TO-EARN VIDEO GAMES DRENCHED IN STORY AND BEAUTIFUL ARTWORK.</div>
		                   <ul className="social-links">
		                   		{data[0].iconsData && data[0].iconsData.map((item , i) => (
		                   			<li><a href="https://twitter.com/theattackwagon"><span key={i} className={item.icoClass}></span></a></li>
		                   		))}
		                   </ul>
		                 </div>
		             </div>
		         </div>


		         <div className="footer-column col-md-6 col-sm-6 col-xs-12">
		             <div className="footer-widget contact-widget">
		                 <h3 className="has-line-center">Contact Us</h3>
		                 <div className="widget-content">
		                     <ul className="contact-info">
                         For inqueries or issues purchasing land, please use the email below.
		                         <li><div className="icon"><span className="flaticon-support"></span></div></li>
		                         {"land@attackwagon.com"}
		                         {/*data[1].infoData && data[1].infoData.map((item , i) => (
		                         	<li key={i}>{item.text}</li>
		                         ))*/}
		                     </ul>
		                 </div>
		             </div>
		         </div>

		     </div>
		 </div>
		</div>
    </footer>
  )
}

export default Footer
